import _ from 'lodash'
import { useContext, useMemo } from 'react'
import { FrameworkContext } from '../FrameworkContent'
import { ParentContext } from '../ParentContext'

export const useGridItems = ({ viewItems }) => {

  const parentContext = useContext(ParentContext)
  const { states, settings } = parentContext ?? {}
  const { currentSettings_state } = states

  // frameworkContext   
  const { framework_state } = useContext(FrameworkContext) ?? {}
  const { desktopMode } = framework_state ?? {}

  // pageContext  
  const { aps_viewItems } = _.get(currentSettings_state, 'gvviSettings', {});

  const getGVIProps = (vit, viewItem) => {

    const viewItem_g = aps_viewItems[vit]
    const { display: display_g } = viewItem_g ?? {}
    const { display, desktopDisplay } = viewItem ?? {}
    const _display = desktopMode && desktopDisplay ? desktopDisplay : display

    let { caption, defaultIcon, iconImage, useIconImage } = display_g ?? {}

    caption = _display && _display.caption ? _display.caption : caption
    defaultIcon = _display && _display.defaultIcon ? _display.defaultIcon : defaultIcon

    iconImage = useIconImage && iconImage ? iconImage : null

    const segProps = {}
    //   caption: caption ? caption : _.startCase(vit) + '*',
    //   icon: defaultIcon ? defaultIcon : 'file alternate',
    //   iconImage: iconImage ? iconImage : null,
    // }

    if (caption) { segProps.caption = caption }
    if (defaultIcon) { segProps.icon = defaultIcon }

    return {
      key: vit,
      // viewItem,
      segProps
    }

  }

  const gridProps = useMemo(() => {
    const _gridProps = {}
    _.forEach(viewItems, (viewItem, vik) => {
      _gridProps[vik] = getGVIProps(vik, viewItem)
    })
    return _gridProps
  }, [viewItems])


  return gridProps

}
